// extracted by mini-css-extract-plugin
module.exports = {"learnMore":"learnMore-1D9Gy"};